// Wishlist functionality
const Wishlist = {
  init() {
    this.items = this.getItems();
    this.updateHeaderCount();
    this.bindEvents();
  },
  
  getItems() {
    const items = localStorage.getItem('wishlist');
    return items ? JSON.parse(items) : [];
  },
  
  saveItems() {
    localStorage.setItem('wishlist', JSON.stringify(this.items));
    this.updateHeaderCount();
  },
  
  addItem(productId, productTitle, productUrl, productImage, productPrice) {
    if (!this.items.find(item => item.id === productId)) {
      this.items.push({
        id: productId,
        title: productTitle,
        url: productUrl,
        image: productImage,
        price: productPrice
      });
      this.saveItems();
    }
  },
  
  removeItem(productId) {
    this.items = this.items.filter(item => item.id !== productId);
    this.saveItems();
  },
  
  toggleItem(productId, productTitle, productUrl, productImage, productPrice) {
    if (this.items.find(item => item.id === productId)) {
      this.removeItem(productId);
      return false;
    } else {
      this.addItem(productId, productTitle, productUrl, productImage, productPrice);
      return true;
    }
  },
  
  updateHeaderCount() {
    const countElement = document.querySelector('.wishlist-count');
    if (countElement) {
      countElement.textContent = this.items.length;
      countElement.style.display = this.items.length > 0 ? 'block' : 'none';
    }
  },
  
  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.wishlist-btn')) {
        e.preventDefault();
        const btn = e.target.closest('.wishlist-btn');
        const productId = btn.dataset.productId;
        const productTitle = btn.dataset.productTitle;
        const productUrl = btn.dataset.productUrl;
        const productImage = btn.dataset.productImage;
        const productPrice = btn.dataset.productPrice;
        
        const isAdded = this.toggleItem(productId, productTitle, productUrl, productImage, productPrice);
        btn.classList.toggle('active', isAdded);
      }
    });
  }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  Wishlist.init();
});
